import { combineReducers } from "redux";
import auth from "./auth";
import listing from "./listing";
import cart from "./cart";

// This file combines reducers
// Each reducer we make needs to be added below to "Connect" it to the rest of the app

export default combineReducers({ auth, listing, cart });
